import React from 'react';
import { Typography } from '@mui/material';
import { StyledProjectInputItem } from './index.style';

const ProjectInputItem = ({ title, logo, option, onSelect }) => {
  const handleSelectInputType = () => {
    onSelect(title, option);
  };

  return (
    <StyledProjectInputItem>
      <div
        role="button"
        className="img-wrapper"
        tabIndex="0"
        onClick={handleSelectInputType}
      >
        <div className="img-item">
          <img src={logo} alt={title} />
        </div>
      </div>
      <Typography className="card-title">{title}</Typography>
    </StyledProjectInputItem>
  );
};

export default ProjectInputItem;
